// @flow
import {
  DELETE_PROGRESS_NOTE_LOADING,
  DELETE_PROGRESS_NOTE_SUCCESS,
  DELETE_PROGRESS_NOTE_ERROR,
  ADD_PROGRESS_NOTE_LOADING,
  ADD_PROGRESS_NOTE_SUCCESS,
  ADD_PROGRESS_NOTE_ERROR,
  UPDATE_PROGRESS_NOTE_LOADING,
  UPDATE_PROGRESS_NOTE_SUCCESS,
  UPDATE_PROGRESS_NOTE_ERROR,
} from '../actions/progressNoteActions';

export default (state: Object = {}, action: Object) => {
  switch (action.type) {
    case DELETE_PROGRESS_NOTE_LOADING:
    case ADD_PROGRESS_NOTE_LOADING:
    case UPDATE_PROGRESS_NOTE_LOADING:
      return {
        ...state,
        status: 'LOADING',
      };
    case DELETE_PROGRESS_NOTE_SUCCESS:
    case ADD_PROGRESS_NOTE_SUCCESS:
    case UPDATE_PROGRESS_NOTE_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        data: action.data,
      };
    case DELETE_PROGRESS_NOTE_ERROR:
    case ADD_PROGRESS_NOTE_ERROR:
    case UPDATE_PROGRESS_NOTE_ERROR:
      return {
        ...state,
        status: 'ERROR',
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/progressNoteReducer.js